/**
 * Section Controller
 * Handles collapsible section state persistence
 */
export class SectionController {
  constructor(storageService) {
    this.storage = storageService;
    this.sectionStates = {};
  }

  async init() {
    this.sectionStates = await this.storage.getSectionStates();
    this._bindEvents();
    this._applyInitialStates();
  }

  _bindEvents() {
    document.addEventListener('click', async (e) => {
      const header = e.target.closest('.section-header');
      if (!header) return;

      const section = header.closest('.portal-section');
      if (!section) return;

      const sectionId = section.dataset.sectionId;
      if (!sectionId) return;

      await this.toggleSection(sectionId);
    });
  }

  _applyInitialStates() {
    const sections = document.querySelectorAll('.portal-section[data-section-id]');
    sections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      const isCollapsed = this.sectionStates[sectionId] ?? this._getDefaultState(sectionId);
      this._setSectionCollapsed(section, isCollapsed, false);
    });
  }

  _getDefaultState(sectionId) {
    // Recently used is collapsed by default
    return sectionId === 'recentlyUsed';
  }

  async toggleSection(sectionId) {
    const section = document.querySelector(`.portal-section[data-section-id="${sectionId}"]`);
    if (!section) return;

    const isCurrentlyCollapsed = this.sectionStates[sectionId] ?? this._getDefaultState(sectionId);
    const newState = !isCurrentlyCollapsed;

    this.sectionStates = await this.storage.setSectionState(sectionId, newState);
    this._setSectionCollapsed(section, newState, true);
  }

  _setSectionCollapsed(section, collapsed, animate = true) {
    const header = section.querySelector('.section-header');
    const content = section.querySelector('.section-content');

    if (header) {
      header.classList.toggle('collapsed', collapsed);
    }

    if (content) {
      if (animate) {
        // Animate the collapse/expand
        if (collapsed) {
          content.style.maxHeight = content.scrollHeight + 'px';
          // Force reflow
          content.offsetHeight;
          content.classList.add('collapsed');
          content.style.maxHeight = '0';
        } else {
          content.classList.remove('collapsed');
          content.style.maxHeight = content.scrollHeight + 'px';
          // Remove max-height after animation
          setTimeout(() => {
            if (!content.classList.contains('collapsed')) {
              content.style.maxHeight = '';
            }
          }, 300);
        }
      } else {
        // No animation - just set state
        content.classList.toggle('collapsed', collapsed);
        content.style.maxHeight = collapsed ? '0' : '';
      }
    }
  }
}
